import { Component } from 'solid-js';
import IconButton from '../IconButton/IconButton';
import { BtnClasses } from '../../types/common';
import { TempSvgIcon } from '../icons/get-svg-icon';

interface ActionButtonProps {
  onClick?(): void;
  icon: string | TempSvgIcon;
  title: string;
  testId?: string;
  disabled?: boolean;
  iconSize?: 'icon-small' | 'icon-medium' | 'icon-large';
}

/**
 * Wrapper around IconButton providing consistent defaults appropriate for use
 * in panel actions
 */
export const ActionButton: Component<ActionButtonProps> = (props) => {
  return (
    <IconButton
      buttonClasses="min-w-8"
      clicked={() => props.onClick?.()}
      icon={props.icon}
      title={props.title}
      size={props.iconSize || 'icon-small'}
      shape="icon-circle"
      color={BtnClasses.TERTIARY}
      data-cy={props.testId}
      disabled={props.disabled}
    />
  );
};

export default ActionButton;
